import React from 'react'
import { Sort } from '../../Component/Component'
import SearchBlock from '../../Component/SearchBlock'

const FullFunctional = ({
    additionalData,
    noneSelectUpdatedPictures,
    setUpdatedPictures,
    setSortReducer,
    setSortSearch,
    sortSearch,
    dispatchAction,
    setSearchMainName,
    updatedPictures,
    valueTabsSort,
    setPageNumber,
    setPageSize,
    productSort,
    hideMarked,
    pageNumber,
    sortItems,
    typeSort,
    sortType,
    pageSize,
    getSlug,
    showAll,
    search,
    slug,
    view,
    get,
}) => {
    return (
        <div className="disk disk--full-functional">
            <SearchBlock
                embedded
                sortSearch={sortSearch}
                setSortSearch={setSortSearch}
                search={search}
                setSearchMainName={setSearchMainName}
                sortType={sortType}
                productSort={productSort}
                get={get}
                additionalData={additionalData}
                setPageNumber={setPageNumber}
            />

            <Sort
                embedded
                noneSelectUpdatedPictures={noneSelectUpdatedPictures}
                additionalData={additionalData}
                search={search}
                sortSearch={sortSearch}
                sortType={sortType}
                setSortReducer={setSortReducer}
                dispatchAction={dispatchAction}
                valueTabsSort={valueTabsSort}
                productSort={productSort || null}
                setUpdatedPictures={setUpdatedPictures}
                updatedPictures={updatedPictures}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                hideMarked={hideMarked}
                pageNumber={pageNumber}
                get={get || null}
                sortItems={sortItems}
                typeSort={typeSort}
                pageSize={pageSize}
                getSlug={getSlug}
                showAll={showAll}
                slug={slug}
            />
        </div>
    )
}

export default FullFunctional
